import * as React from "react"

export type ShellContextValue = {
  currentWorkspaceId: string | null
  setCurrentWorkspaceId: (id: string | null) => void
  commandPaletteOpen: boolean
  setCommandPaletteOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const ShellContext = React.createContext<ShellContextValue | null>(null)

export function useShell() {
  const ctx = React.useContext(ShellContext)
  if (!ctx) throw new Error("useShell must be used within <ShellProvider />")
  return ctx
}
